/**
 * The two legacy Quill model tier slots and their display labels.
 *
 * RETIRED as a control surface by migration 528 (2026-08-03 pipeline-model audit,
 * finding 3): nothing in quill-engine resolves through quill_model_defaults any
 * more, so these slots no longer decide which model runs. They survive as labels
 * for the read-only record and its change log on the AI Models page.
 *
 * This used to live in DefaultSlotCard.tsx, which was deleted along with
 * ChangeDefaultDialog.tsx — both existed only to drive PUT /models/defaults and
 * POST /models/rollback, which now answer 410 GONE.
 */

import { ModelSlot } from '../../../services/quillAdminService';

export const SLOT_LABELS: Record<ModelSlot, string> = {
  text: 'Text (primary)',
  text_fast: 'Text (fast)',
};
